// extracted by mini-css-extract-plugin
module.exports = {"emoji":"emoji--34ryz"};